import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import WarningIcon from "@mui/icons-material/Warning";

import Alert from "@mui/material/Alert";
import React from "react";
import { useSelector } from "react-redux";
import { DbOrderBasketItemInfos } from "../../../Core/Api/Types/db-order-basket-item-infos";
import { OrderProductType } from "../../../Core/Api/Types/order-product-type";
import {
  GetBasketBundleProfiles,
  GetBasketProfiles,
  IsBasketUnitApiCallLoading,
} from "../../../Redux/Reducers/redux-slice-basket";
import { GetSectionIsValid } from "../../../Redux/Reducers/redux-slice-form-validation";
import { useAppSelector } from "../../../Redux/redux-store";
import { IsBasketItemMissingAsset } from "../../../Utils/Helpers/IntelliTranskode/intellitranskode-helpers";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
interface ConfigSaveButtonProps {
  onSubmit: () => void;
  item: DbOrderBasketItemInfos;
  disabled: boolean;
}

const ConfigSaveButton: React.FC<ConfigSaveButtonProps> = (props) => {
  const { t } = useTranslation();
  const { onSubmit, item, disabled = false } = props;
  const formId = `form-bundle-${item.id}`;
  const formSectionComposer = useAppSelector(GetSectionIsValid(formId, "sectionComposer"));
  const loading = useSelector(IsBasketUnitApiCallLoading);
  const profiles = useAppSelector(GetBasketProfiles);
  const bundleProfiles = useAppSelector(GetBasketBundleProfiles);

  const missingAssets = IsBasketItemMissingAsset(item, profiles, bundleProfiles);
  const missingAttachments = React.useMemo(() => {
    return item.selectedProduct?.isDeliveryAttachmentMandatory && item.deliveryFileTransferId === null;
  }, [item]);

  return (
    <>
      {(item.selectedProduct?.type !== OrderProductType.TranscodeBundleByProfile || formSectionComposer) &&
        missingAssets.missing && (
          <Alert color="warning" sx={{ mt: 3 }} icon={<WarningIcon />}>
            {t("alert:warning.configIsMissingAtLeastOneAsset", {
              assets: missingAssets.fields.map((f) => f.message).join(", "),
            })}
            .
          </Alert>
        )}
      <Button
        onClick={onSubmit}
        color="primary"
        variant="contained"
        endIcon={<ArrowForwardIcon />}
        sx={{ mt: 3 }}
        disabled={disabled || missingAssets.fields.filter((x) => x.locked).length > 0 || missingAttachments}
        loading={loading}
      >
        {t("button:saveConfiguration")}
      </Button>
    </>
  );
};

export default ConfigSaveButton;
